<template>
  <div>
    <PageHeader>
      <template v-slot:header>行動要素設定</template>
      <template v-slot:annotation>
        評価基準となる行動のカテゴリーを設定します。具体的な項目は年度設定にて設定することができます。
      </template>
    </PageHeader>

    <v-row>
      <v-col cols="6" sm="6" md="4" lg="2">
        <Button @click="onClickActionElementEditOpen(null)" color="primary"
          >新規追加</Button
        >
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="items"
          @click:row="onClickActionElementEditOpen"
          :loading="loading"
          loading-text="読み込み中..."
          no-data-text="行動要素は見つかりませんでした。新規追加ボタンより行動要素を設定してください。"
        >
          <template v-slot:[`item.IS_ACTIVE`]="{ item }">
            <span v-if="item.IS_ACTIVE">使用中</span>
            <span v-else>使用停止</span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <Loader :loading="loading" />
    <BehavioralElementEdit
      ref="edit"
      @edit="editActionElementInfo"
      @closeEdit="closeEdit"
    />
    <DialogMessage ref="dialog" />
  </div>
</template>

<script>
import BehavioralElementEdit from './BehavioralElementEdit.vue';
import axios from 'axios';
import config from '../../../const.js';
import message from '../../../message.js';
import { getSessionStorageItem } from '../../../common.js';

export default {
  name: 'BehavioralElement',
  components: { BehavioralElementEdit },

  data() {
    return {
      loading: false,
      items: [],

      headers: [
        {
          text: '表示順',
          align: 'left',
          value: 'SHOW_ORDER',
        },
        {
          text: '行動要素名',
          align: 'left',
          value: 'ACT_EMT_NAME',
        },

        {
          text: '使用状態',
          align: 'left',
          value: 'EXPIRATION_NAME',
        },
      ],
    };
  },

  created() {
    this.getActionElement();
  },

  methods: {
    onClickActionElementEditOpen(item) {
      // 行動要素編集画面を表示
      if (item == null) {
        this.$refs.edit.open(null, { color: 'red' });
      } else {
        this.$refs.edit.open(item, { color: 'red' });
      }
    },
    editActionElementInfo() {
      // 行動要素情報取得
      this.getActionElement();
    },
    async getActionElement() {
      this.loading = true;

      // ユーザ情報取得
      let userInfo = getSessionStorageItem();

      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }

      let vm = this;

      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/action/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // 等級データ取得
          vm.items = response.data;
          for (var i = 0; i < this.items.length; i++) {
            //使用状態
            if (this.items[i].EXPIRATION == config.USE_IN) {
              this.items[i].EXPIRATION_NAME = config.USE_IN_NAME;
            } else if (this.items[i].EXPIRATION == config.USE_STOP) {
              this.items[i].EXPIRATION_NAME = config.USE_STOP_NAME;
            }
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
      // ローディング画像終了
      this.loading = false;
    },

    closeEdit() {
      this.getActionElement();
    },
  },
};
</script>
